import React, { ReactNode } from "react";
import { twclsx } from "../../utils/cssUtil";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  loading?: boolean;
}

export function Button({
  children,
  className,
  loading = false,
  onClick,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      className={twclsx(
        "btn",
        (!className || className.indexOf("btn-") < 0) &&
          "bg-gradient-to-r from-secondary via-secondary to-accent outline-primary text-white",
        className,
      )}
      onClick={(e) => {
        if (loading) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        onClick?.(e);
      }}
    >
      {loading && <span className={"loading loading-spinner"}></span>}
      {children}
    </button>
  );
}
